import { BaseMapper } from '@ps/utils';
import { DashboardPreference } from '@ps/user-settings-models';
import { DashboardPreferenceDto } from '../dtos/dashboard-preference.dto';

export class DashboardPreferenceMapper extends BaseMapper<
  DashboardPreferenceDto,
  DashboardPreference
> {
  private readonly _keyMap: Record<string, DashboardPreference['key']> = {
    status: 'status',
    surveyId: 'id',
    surveyTitle: 'title',
    fielded: 'fielded',
    inProgress: 'inProgress',
    averageCpi: 'avgCpi',
    expected_loi: 'expectedLoi',
    currentIR: 'currentIr',
    countryCode: 'countryCode',
    current_cost: 'currentCost',
    survey_launch_date: 'launchDate',
    billing_id: 'billingId',
    template: 'template',
    buyer_pm: 'buyerPm',
    reconciled: 'reconciliation',
    crm_id: 'crmId',
    epc: 'earningsPerClick',
    buyer_account: 'companyName',
    actual_margin: 'actualMargin',
    margin_bank: 'marginBank',
    operator_pm: 'operatorPm',

    // widget keys
    groupedSurveys: 'groupedSurveys',
    healthCheck: 'healthCheck',
    trafficChannels: 'trafficChannels',
    pacing: 'pacing',
    score: 'score',
  };

  public fromDto(dto: DashboardPreferenceDto): DashboardPreference {
    return {
      id: dto.id,
      key: this._keyMap[dto.key],
      order: dto.order,
      column: dto.column,
      mobile: dto.mobile,
      desktop: dto.desktop,
      selected: dto.selected,
      isDefault: dto.isDefault,
    };
  }

  public override fromDtoList(
    dtos: DashboardPreferenceDto[],
  ): DashboardPreference[] {
    return dtos
      .filter((dto) => dto.key in this._keyMap)
      .map((dto) => this.fromDto(dto));
  }
}
